function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoNFTCard = require('../../../../../lib/saito/ui/saito-nft/saito-nft-card');
var NftSelectionTemplate = require('./nft-selection.template');
var ArcadeNftSelectionOverlay = /*#__PURE__*/function () {
  function ArcadeNftSelectionOverlay(app, mod) {
    _classCallCheck(this, ArcadeNftSelectionOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.card_list = [];
    this.draft_selected = new Map();
    this.supported_nft_types = [];
    this.owner = '';
    this.onConfirm = null;
  }
  return _createClass(ArcadeNftSelectionOverlay, [{
    key: "returnRecordType",
    value: function returnRecordType() {
      var rec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      try {
        var _rec$slip;
        return this.app.wallet.extractNFTType((rec === null || rec === void 0 || (_rec$slip = rec.slip3) === null || _rec$slip === void 0 ? void 0 : _rec$slip.utxo_key) || '') || '';
      } catch (_) {
        return '';
      }
    }
  }, {
    key: "matchesSupportedType",
    value: function matchesSupportedType() {
      var nft_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.supported_nft_types.includes(nft_type);
    }
  }, {
    key: "dedupeNftRecords",
    value: function dedupeNftRecords() {
      var nft_list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var seen = new Set();
      var unique = [];
      var _iterator = _createForOfIteratorHelper(nft_list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rec = _step.value;
          var id = rec === null || rec === void 0 ? void 0 : rec.id;
          if (id == null || id === '') {
            unique.push(rec);
            continue;
          }
          var key = String(id);
          if (seen.has(key)) {
            continue;
          }
          seen.add(key);
          unique.push(rec);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return unique;
    }
  }, {
    key: "recordFromNft",
    value: function recordFromNft(nft) {
      var _nft$id;
      var nft_type = (typeof (nft === null || nft === void 0 ? void 0 : nft.returnType) === 'function' ? nft.returnType() : '') || (nft === null || nft === void 0 ? void 0 : nft.nft_type) || this.returnRecordType({
        slip3: nft === null || nft === void 0 ? void 0 : nft.slip3
      }) || '';
      return {
        title: (nft === null || nft === void 0 ? void 0 : nft.title) || '',
        id: String((_nft$id = nft === null || nft === void 0 ? void 0 : nft.id) !== null && _nft$id !== void 0 ? _nft$id : ''),
        owner: this.owner,
        nft_type: nft_type
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$app;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$supported_nft_ty = _ref.supported_nft_types,
        supported_nft_types = _ref$supported_nft_ty === void 0 ? [] : _ref$supported_nft_ty,
        _ref$initially_select = _ref.initially_selected,
        initially_selected = _ref$initially_select === void 0 ? [] : _ref$initially_select,
        _ref$owner = _ref.owner,
        owner = _ref$owner === void 0 ? '' : _ref$owner,
        _ref$onConfirm = _ref.onConfirm,
        onConfirm = _ref$onConfirm === void 0 ? null : _ref$onConfirm;
      this.supported_nft_types = Array.isArray(supported_nft_types) ? supported_nft_types : [];
      this.owner = owner || this.mod.publicKey || '';
      this.onConfirm = typeof onConfirm === 'function' ? onConfirm : null;
      this.draft_selected = new Map();
      var _iterator2 = _createForOfIteratorHelper(initially_selected || []),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rec = _step2.value;
          if ((rec === null || rec === void 0 ? void 0 : rec.id) != null && rec.id !== '') {
            this.draft_selected.set(String(rec.id), {
              title: rec.title || '',
              id: String(rec.id),
              owner: rec.owner || this.owner,
              nft_type: rec.nft_type || ''
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.overlay.show(NftSelectionTemplate());
      if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.browser) !== null && _this$app !== void 0 && _this$app.addStylesheet) {
        this.app.browser.addStylesheet('/saito/css-imports/ui/saito-nft.css');
      }
      this.attachConfirmEvent();
      void this.renderNftGrid();
    }
  }, {
    key: "renderNftGrid",
    value: function () {
      var _renderNftGrid = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var container, instructionsEl, nft_list, _iterator3, _step3, _loop, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              container = document.querySelector('#arcade-nft-selection-overlay [data-nft-grid]');
              instructionsEl = document.querySelector('#arcade-nft-selection-overlay [data-nft-instructions]');
              if (container) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return this.app.wallet.updateNFTList();
            case 2:
              nft_list = this.dedupeNftRecords((this.app.options.wallet.nfts || []).filter(function (rec) {
                return _this.matchesSupportedType(_this.returnRecordType(rec));
              }));
              this.card_list = [];
              container.innerHTML = '';
              if (nft_list.length) {
                _context2.n = 3;
                break;
              }
              if (instructionsEl) {
                instructionsEl.innerHTML = "\n          <div class=\"instructions\">\n            No matching NFTs were found in your wallet.\n          </div>\n        ";
              }
              return _context2.a(2);
            case 3:
              if (instructionsEl) {
                instructionsEl.innerHTML = '';
              }
              _iterator3 = _createForOfIteratorHelper(nft_list);
              _context2.p = 4;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var rec, card, id, existing;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      rec = _step3.value;
                      card = new SaitoNFTCard(_this.app, _this.mod, '#arcade-nft-selection-overlay [data-nft-grid]', null, rec, function (nft) {
                        return _this.toggleSelection(nft, card);
                      });
                      _this.card_list.push(card);
                      _context.n = 1;
                      return card.render();
                    case 1:
                      id = (rec === null || rec === void 0 ? void 0 : rec.id) != null ? String(rec.id) : '';
                      if (id && _this.draft_selected.has(id)) {
                        _this.markCardSelected(card, true);
                        existing = _this.draft_selected.get(id);
                        if (card.nft) {
                          _this.draft_selected.set(id, _objectSpread(_objectSpread(_objectSpread({}, existing), _this.recordFromNft(card.nft)), {}, {
                            title: card.nft.title || existing.title || ''
                          }));
                        }
                      }
                    case 2:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _iterator3.s();
            case 5:
              if ((_step3 = _iterator3.n()).done) {
                _context2.n = 7;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 6);
            case 6:
              _context2.n = 5;
              break;
            case 7:
              _context2.n = 9;
              break;
            case 8:
              _context2.p = 8;
              _t = _context2.v;
              _iterator3.e(_t);
            case 9:
              _context2.p = 9;
              _iterator3.f();
              return _context2.f(9);
            case 10:
              return _context2.a(2);
          }
        }, _callee, this, [[4, 8, 9, 10]]);
      }));
      function renderNftGrid() {
        return _renderNftGrid.apply(this, arguments);
      }
      return renderNftGrid;
    }()
  }, {
    key: "markCardSelected",
    value: function markCardSelected(card, selected) {
      var el = document.querySelector(card.my_qs);
      if (el) {
        el.classList.toggle('selected', !!selected);
      }
    }
  }, {
    key: "toggleSelection",
    value: function toggleSelection(nft, card) {
      if ((nft === null || nft === void 0 ? void 0 : nft.id) == null || nft.id === '') {
        return;
      }
      var id = String(nft.id);
      if (this.draft_selected.has(id)) {
        this.draft_selected["delete"](id);
        this.markCardSelected(card, false);
        return;
      }
      this.draft_selected.set(id, this.recordFromNft(nft));
      this.markCardSelected(card, true);
    }
  }, {
    key: "confirmedRecords",
    value: function confirmedRecords() {
      var _this2 = this;
      var records = [];
      var _iterator4 = _createForOfIteratorHelper(this.draft_selected),
        _step4;
      try {
        var _loop2 = function _loop2() {
          var _step4$value = _slicedToArray(_step4.value, 2),
            id = _step4$value[0],
            rec = _step4$value[1];
          var card = _this2.card_list.find(function (c) {
            var _c$nft;
            return String(c === null || c === void 0 || (_c$nft = c.nft) === null || _c$nft === void 0 ? void 0 : _c$nft.id) === id;
          });
          if (card !== null && card !== void 0 && card.nft) {
            records.push(_this2.recordFromNft(card.nft));
          } else {
            records.push(rec);
          }
        };
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return records;
    }
  }, {
    key: "attachConfirmEvent",
    value: function attachConfirmEvent() {
      var _this3 = this;
      var btn = document.getElementById('arcade-nft-selection-confirm');
      if (!btn) {
        return;
      }
      btn.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var records = _this3.confirmedRecords();
        _this3.overlay.close();
        if (_this3.onConfirm) {
          _this3.onConfirm(records);
        }
      };
    }
  }]);
}();
module.exports = ArcadeNftSelectionOverlay;